import { createRouter, createWebHistory } from "vue-router";
import Chat from "../views/Chat.vue";

const routes = [
  {
    path: "/",
    name: "Chat",
    component: Chat,
  },
  {
    path: "/test",
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
